<div class="content-with-stepper-and-title">
    <main class="field col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12 px-0">
        <h3 class="sub-title">
            {{copyService.copies.incomes_second_headline.subtitle}}
        </h3>
        <br>
        <form [formGroup]="formGroup">
            <div>
                <voxel-radio-button-group formControlName="selection_incomes_second_headline">
                    <voxel-radio-button *ngFor="let selectionList of listIncomesSecondLine" [checked]="selectionList.checked" [value]="selectionList.value">{{selectionList.label}}</voxel-radio-button>
                </voxel-radio-button-group>
            </div>
        </form>
    </main>
    <app-controls [hasPrevious]="true" [nextLabel]="copyService.copies.incomes_second_headline.button" [nextDisabled]="!formGroup.valid" (next)="next()"></app-controls>
</div>